import { get } from 'lodash';

export const ErrorScrollElement = ({ errors, isValid, isSubmitting }) => {
  const arrayKeys = Object.keys(errors);
  if (!isValid && isSubmitting && arrayKeys.length > 0) {
    // Always get the final modal in case nest modal.
    const modalElement = document.querySelectorAll('.modal')[
      document.querySelectorAll('.modal').length - 1
    ];
    const element = document.getElementsByName(arrayKeys[0])[0];
    if (element) {
      const elementRect = element.getBoundingClientRect();
      if (modalElement) {
        const modalElementRect = modalElement.getBoundingClientRect();
        const offset = elementRect.top - modalElementRect.top;
        modalElement.scrollTo({
          top: offset - 100,
          behavior: 'smooth',
        });
      } else {
        const bodyRect = document.body.getBoundingClientRect();
        const offset = elementRect.top - bodyRect.top;
        global.window.scrollTo({
          top: offset - 100,
          behavior: 'smooth',
        });
      }
    }
  }
};

// For select field, cant remove initial data
export const fixedValue = (list) => list.map((el) => ({ ...el, isFixed: true }));

export const getMessageErrorArrayField = (errors, name, index, fieldName) => {
  return get(errors, `${name}.${index}.${fieldName}`) || '';
};
